<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Reglas de la API de clientes</h4>
            <div class="small text-muted">
              El cliente informa tipo de pedido y modalidad; la regla define el motivo. Modalidad vacía = cualquier
              modalidad de ese tipo (si hay una regla con la modalidad exacta, gana esa). Un pedido que no coincide con
              ninguna regla entra con el motivo DROP SHIPPING en estado Error: corregilo, creá la regla y sincronizalo.
            </div>
          </b-col>

          <b-col sm="5">
            <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Regla">
              <i class="fa fa-plus"></i> Agregar
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-table class="mb-0"
                    ref="table"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">

                <template v-slot:cell(id)="data">
                  <b>#{{data.item.id}}</b>
                </template>

                <template v-slot:cell(modality)="data">
                  <span v-if="data.item.modality">{{data.item.modality}}</span>
                  <i v-else class="text-muted">(cualquiera)</i>
                </template>

                <template v-slot:cell(reason)="data">
                  <span v-if="data.item.reason">{{data.item.reason.name}}</span>
                </template>

                <template v-slot:cell(active)="data">
                  <b-badge :variant="data.item.active ? 'success' : 'secondary'">{{data.item.active ? 'Activa' : 'Inactiva'}}</b-badge>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">
                    <b-dropdown-item @click="edit(data.item)">
                      <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No hay reglas cargadas</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white">
        <div slot="modal-header">
          {{this.modal.form.title}}
        </div>

        <b-row>
          <b-col md="6" class="mb-2">
            <b-form-group label="Tipo de pedido" description="Tal cual lo manda el cliente (ej: me2)">
              <b-form-input size="sm" v-model="crud.form.order_type" placeholder="me2"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" class="mb-2">
            <b-form-group label="Modalidad" description="Vacío = cualquier modalidad">
              <b-form-input size="sm" v-model="crud.form.modality" placeholder="flex"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12" class="mb-2">
            <b-form-group label="Motivo (grupo de facturación)">
              <b-form-select size="sm" v-model="crud.form.reason_id" :options="opcionesMotivos"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-checkbox v-model="crud.form.active" switch>Activa</b-form-checkbox>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'

  export default {
    data: () => {
      return {
        access: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudOrdersApiRules',
          elements: {}
        },
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', class: 'align-middle'},
            {key: 'order_type', label: 'Tipo de pedido', class: 'align-middle'},
            {key: 'modality', label: 'Modalidad', class: 'align-middle'},
            {key: 'reason', label: 'Motivo', class: 'align-middle'},
            {key: 'active', label: 'Estado', class: 'text-center align-middle'},
            {key: 'f_action', label:'', class: 'text-right align-middle'},
          ],
          isBusy: false,
        },
        crud: {
          form: {
            id: 0,
            order_type: '',
            modality: '',
            reason_id: null,
            active: true,
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
        motivos: [],
      }
    },
    computed: {
      // Activos, más el de la regla en edición aunque se haya desactivado (para no perderlo del select)
      opcionesMotivos() {
        var opciones = [{ value: null, text: 'Elegí un motivo...' }]
        this.motivos
          .filter((m) => m.active || m.id === this.crud.form.reason_id)
          .forEach((m) => opciones.push({ value: m.id, text: (m.reference ? m.reference + ' - ' : '') + m.name + (m.active ? '' : ' (inactivo)') }))
        return opciones
      },
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.loadMotivos()
      this.load()
    },
    methods: {
      loadMotivos() {
        serviceAPI.obtenerMotivos()
          .then((response) => { this.motivos = response.data })
          .catch((error) => this.$awn.alert(Error.showError(error)))
      },
      load() {
        this.table.isBusy = true
        serviceAPI.obtenerReglasApi()
          .then((response) => {
            this.table.items = response.data
            this.table.isBusy = false
          })
          .catch((error) => {
            this.table.isBusy = false
            this.$awn.alert(Error.showError(error))
          })
      },
      add() {
        this.crud.form = { id: 0, order_type: '', modality: '', reason_id: null, active: true }
        this.modal.form.title = "Nueva Regla"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form = {
          id: item.id,
          order_type: item.order_type,
          modality: item.modality || '',
          reason_id: item.reason_id,
          active: !!item.active,
        }
        this.modal.form.title = "Editar Regla"
        this.modal.form.active = true
      },
      remove(item) {
        var texto = item.order_type + (item.modality ? ' / ' + item.modality : '')
        this.$bvModal.msgBoxConfirm('¿Desea borrar la regla (' + item.id + ') - ' + texto + '?', {
          title: 'Borrar Regla',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            serviceAPI.eliminarReglaApi(item.id)
              .then(() => {
                loader.hide()
                this.load()
                this.$awn.success("Regla eliminada");
              })
              .catch(error => {
                loader.hide()
                this.$awn.alert(Error.showError(error));
              })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();

        var result = this.crud.form.id
          ? serviceAPI.editarReglaApi(this.crud.form)
          : serviceAPI.agregarReglaApi(this.crud.form)

        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Cambios guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
    }
  }
</script>
